module.exports = __webpack_public_path__ + "5b3314784995b95669e69a4b60b1a4fa.pdf";